<div class="button-wrap {{ theme }}">
  <ng-container>
    <button
      pButton
      [type]="type"
      [class]="class"
      (click)="click($event)"
      [loading]="isLoading"
      [disabled]="disabled"
    >
      <sxw-svg-icon
        *ngIf="icon && iconPos === 'left'"
        [name]="icon"
        [fillColor]="leftIconFill"
        [width]="iconWidth"
        [height]="iconHeight"
      ></sxw-svg-icon>
      <span>{{ label | translate }}</span>
      <sxw-svg-icon
        *ngIf="icon && iconPos === 'right'"
        [name]="icon"
        [fillColor]="rightIconFill"
        [width]="iconWidth"
        [height]="iconHeight"
      ></sxw-svg-icon>
    </button>
  </ng-container>
</div>
